import React from 'react';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import ContentRelatorios from './ContentRelatorios';

const Relatorios = () => {
  return (
    <>
      <HeaderApp />
      <ContentRelatorios />
      <Bottom />
    </>
  );
};

export default Relatorios;
